import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

import { SideNavigationProfileMenuComponent } from './side-navigation-profile-menu.component';

@NgModule({
  declarations: [
    SideNavigationProfileMenuComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    // RnplCommonModule,
    RouterModule
  ],
  exports: [SideNavigationProfileMenuComponent],
  entryComponents: [SideNavigationProfileMenuComponent]
})
export class SideNavigationProfileMenuModule { }
